export enum ExternalServiceEvents {
  GAME_SCRIPT_EVENT = 'GAME_SCRIPT_EVENT',
  RECURLY_SUBSCRIPTION_PROCESSING_EVENT = 'RECURLY_SUBSCRIPTION_PROCESSING_EVENT',
}

export interface ExternalServiceEventType<T extends ExternalServiceEvents, D> {
  type: T
  data: D
}
